// 场次核销
export default {
    heard_title: "场次列表",
    // 表单
    fl_scheduleTime: "核销日期:",
    fp_scheduleTime: "请选择核销日期",
    fl_store: "核销门店:",
    fp_store: "请选择核销门店",
    op_all: "全部",
    fl_orderNo: "订单号:",
    fp_orderNo: "请输入订单号",
    fl_proj: "项目:",
    fp_proj: "请选择项目",
    fl_scheduleCode: "场次:",
    fp_scheduleCode: "请输入场次",
    fl_consumed: "全部核销:",
    fp_consumed: "核销状态",
    op_true: "是",
    op_false: "否",
    // 表格
    tl_scheduleTime: "核销日期",
    tl_storeName: "核销门店",
    tl_orderNo: "订单号",
    tl_projectName: "项目名称",
    tl_scheduleCode: "场次",
    tl_consumeQuantity: "核销票数",
    tl_memo: "备注",
    btn_addMemo: "新增备注",

    // 备注弹出框
    dt_memo: "备注",
    dp_memo: "请输入备注内容",

    rm_memo: "请输入备注内容",
    sm_update: "保存成功"
};
